import { API_BASE_URL } from './config';
// #
class AuthService {
    constructor() {

        this.state={
            url: `${API_BASE_URL}/core/api-token-auth/`,
            url_register: `${API_BASE_URL}/core/user_create/`,
            url_info_adicional: `${API_BASE_URL}/core/info_adicional_user/`,
            url_user_data: `${API_BASE_URL}/core/user_data/`,
            url_user_muda_senha: `${API_BASE_URL}/core/mudar-senha/`,
            url_user_muda_senha_com_email: `${API_BASE_URL}/core/reset-senha_email/`,
            url_password_reset_request: `${API_BASE_URL}/core/auth/password-reset/request/`,
            url_password_reset_confirm: `${API_BASE_URL}/core/auth/password-reset/confirm/`,
            url_user_perfil: `${API_BASE_URL}/core/user/perfil/`,

        }
    };

    setLogin(data){
        return fetch(this.state.url, {method:'POST', body:data, headers:{'Content-Type': 'application/json; charset=UTF-8'}})
    };

    setRegister(data){
        return fetch(this.state.url_register, {method:'POST', body:data, headers:{'Content-Type': 'application/json; charset=UTF-8'}})
    };

    setInfoAdicional(data) {
        const headers = { 'Content-Type': 'application/json; charset=UTF-8' };
        const token = sessionStorage.getItem('brv-user-token');
        if (token) {
            headers['Authorization'] = 'Token ' + token;
        }
        return fetch(this.state.url_info_adicional, {
            method: 'POST',
            body: data,
            headers: headers
        });
    };

    setMudaSenha(data){
        return fetch(this.state.url_user_muda_senha, {method:'PATCH', body:data, headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}})
    };

    setMudaSenhaComEmail(data){
        return fetch(this.state.url_user_muda_senha_com_email, {method:'PATCH', body:data, headers:{'Content-Type': 'application/json; charset=UTF-8'}})
    };

    requestPasswordReset(data){
        return fetch(this.state.url_password_reset_request, {method:'POST', body:data, headers:{'Content-Type': 'application/json; charset=UTF-8'}})
    };

    confirmPasswordReset(data){
        return fetch(this.state.url_password_reset_confirm, {method:'POST', body:data, headers:{'Content-Type': 'application/json; charset=UTF-8'}})
    };

    getUserData(data){
        return fetch(this.state.url_user_data+data, {method:'GET',  headers:{'Content-Type': 'application/json; charset=UTF-8','Authorization':'Token '+sessionStorage.getItem('brv-user-token')}});
    };

    async updatePerfil(data){
        const body = typeof data === 'string' ? data : JSON.stringify(data);
        let url = `${API_BASE_URL}/core/user_credentials/`;
        
        try {
            const parsedData = typeof data === 'string' ? JSON.parse(data) : data;
            if (parsedData.id_usuario) {
                url = `${url}${parsedData.id_usuario}/`;
            } else if (parsedData.id) {
                url = `${url}${parsedData.id}/`;
            }
        } catch (e) {
            // Ignore JSON parse errors
        }

        const headers = {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
        };
        let response = await fetch(url, {
            method: 'PATCH',
            body: body,
            headers: headers
        });
        if (response.status === 405) {
            response = await fetch(url, {
                method: 'PUT',
                body: body,
                headers: headers
            });
        }
        if (response.status === 405) {
            response = await fetch(url, {
                method: 'POST',
                body: body,
                headers: headers
            });
        }
        return response;
    };

    async getInfoAdicionalUsuario(usuarioId) {
        const url = `${API_BASE_URL}/core/info_adicional_usuario/retrieve/${usuarioId}/`;
        const headers = {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
        };
        return fetch(url, { method: 'GET', headers: headers });
    };

    async updateInfoAdicional(pk, data) {
        const body = typeof data === 'string' ? data : JSON.stringify(data);
        const url = `${API_BASE_URL}/core/user/update/${pk}/`;
        const headers = {
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': 'Token ' + sessionStorage.getItem('brv-user-token')
        };
        let response = await fetch(url, {
            method: 'PATCH',
            body: body,
            headers: headers
        });
        if (response.status === 405) {
            response = await fetch(url, {
                method: 'PUT',
                body: body,
                headers: headers
            });
        }
        if (response.status === 405) {
            response = await fetch(url, {
                method: 'POST',
                body: body,
                headers: headers
            });
        }
        return response;
    };

}

export default AuthService;
